import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'input-currency',
  templateUrl: './input-currency.component.html',
  styleUrls: ['./input-currency.component.css']
})
export class InputCurrencyComponent implements OnInit {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() maxlength: number = 15;
  @Input() showIconSuccess: boolean = false;
  @Input() class: string = 'form-control';

  constructor(private currencyPipe: CurrencyPipe
  ) { }

  ngOnInit(): void {
    this.control.valueChanges.subscribe(() => { console.log('here');
     this.formatValue(); })
  }

  formatValue() {
    const value = !this.control.value ? 0 : parseInt(this.control.value.replace(/\D/g, '').replace(/^0+/, ''));

    if (!(+value > 0)) {
      this.control.setValue('', { emitEvent: false })
      return;
    }

    this.control.setValue(`$ ${this.currencyPipe.transform(value, "CLP", '', '1.0-0')}`, { emitEvent: false })
  }
}
